/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomSmsBasicAuth
 */
export interface CustomSmsBasicAuth {
    /**
     * 
     * @type {string}
     * @memberof CustomSmsBasicAuth
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSmsBasicAuth
     */
    passwordPlain?: string | null;
}

/**
 * Check if a given object implements the CustomSmsBasicAuth interface.
 */
export function instanceOfCustomSmsBasicAuth(value: object): value is CustomSmsBasicAuth {
    return true;
}

export function CustomSmsBasicAuthFromJSON(json: any): CustomSmsBasicAuth {
    return CustomSmsBasicAuthFromJSONTyped(json, false);
}

export function CustomSmsBasicAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomSmsBasicAuth {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'passwordPlain': json['password_plain'] == null ? undefined : json['password_plain'],
    };
}

export function CustomSmsBasicAuthToJSON(json: any): CustomSmsBasicAuth {
    return CustomSmsBasicAuthToJSONTyped(json, false);
}

export function CustomSmsBasicAuthToJSONTyped(value?: CustomSmsBasicAuth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'password_plain': value['passwordPlain'],
    };
}

